import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {faQuestionCircle, faUser} from '@fortawesome/free-regular-svg-icons';
import {faCar, faChevronRight, faCopy, faHome, faPlusCircle, faSignOutAlt, faSuitcase} from '@fortawesome/free-solid-svg-icons';
import {faCalculator} from '@fortawesome/free-solid-svg-icons/faCalculator';
import {faCertificate} from '@fortawesome/free-solid-svg-icons/faCertificate';
import {faTags} from '@fortawesome/free-solid-svg-icons/faTags';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {LocaleService} from '../../services/locale.service';


@Component({
  selector: 'app-site-menu',
  templateUrl: './site-menu.component.html',
  styleUrls: ['./site-menu.component.scss']
})
export class SiteMenuComponent implements OnInit {

  @Input() user: any;
  @Input() mobile: boolean;
  siteMenu: any[];
  farUser = faUser;
  faSignOut = faSignOutAlt;
  faPlus = faPlusCircle;
  faCopy = faCopy;
  faSuiteCase = faSuitcase;
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() onLogout: EventEmitter<boolean> = new EventEmitter<boolean>();
  faChevronRight = faChevronRight;
  displayElement = true;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private translate: TranslateService,
              public localeService: LocaleService) {
  }

  get isUAERoute(): boolean {
    return this.router.url.startsWith('/uae') || this.router.url.startsWith('/ga') || this.router.url.startsWith('/nigeria');
  }

  get isNigeriaRoute(): boolean {
    return this.router.url.startsWith('/nigeria');
  }


  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.displayElement = !event.url.includes('/naor');

        if (event.url.includes('/uae') || event.url.includes('/ga') || event.url.includes('/nigeria')) {
          this.siteMenu = [
            {
              label: this.translate.instant('HEADER.AVAILABLE_VEHICLES'), routerLink: '/cars', fa_icon: faCar, color: 'white', weight: 'bold',
            },
            {
              label: this.translate.instant('HEADER.AVAILABLE_VEHICLES'), routerLink: '/car-market', fa_icon: faCar, color: 'white', weight: 'bold',
            },
            {
              label: this.translate.instant('HEADER.CALCULATE_COST'), routerLink: '/account/calculate', fa_icon: faCalculator, color: 'white', weight: 'bold',
            },
            {
              label: this.translate.instant('HEADER.ORIGIN_DISCOUNT_CHECK'), routerLink: '/cert-check', fa_icon: faCertificate, color: 'white', weight: 'bold',
            },
            {label: this.translate.instant('HEADER.SUBSCRIBE'), routerLink: '/subscribe', fa_icon: faTags, color: 'white', weight: 'bold'},
            {label: this.translate.instant('HEADER.HOME'), routerLink: '/', fa_icon: faHome},

          ];
        }

      });
    this.buildMenu();
    this.translate.onLangChange.subscribe(() => {
      this.buildMenu();
    });
  }

  private buildMenu() {
    this.siteMenu = [
      {label: this.translate.instant('HEADER.OPEN_ORDER'), routerLink: '/account/basic-order', weight: 'bold', color: 'white',},
      {
        label: this.translate.instant('HEADER.AVAILABLE_VEHICLES'), routerLink: '/cars', fa_icon: faCar, color: 'white', weight: 'bold',
      },
      {
        label: this.translate.instant('HEADER.VEHICLE_BOARD'), routerLink: '/car-market', fa_icon: faCar, color: 'white', weight: 'bold',
      },
      {
        label: this.translate.instant('HEADER.CALCULATE_COST'), routerLink: '/account/calculate', fa_icon: faCalculator, color: 'white', weight: 'bold',
      },
      {
        label: this.translate.instant('HEADER.ORIGIN_DISCOUNT_CHECK'), routerLink: '/cert-check', fa_icon: faCertificate, color: 'white', weight: 'bold',
      },
      {label: this.translate.instant('HEADER.HOME'), routerLink: '/', fa_icon: faHome},
    ];
  }

  hasRole(role: string): boolean {
    return this.user?.userData?.role?.includes(role);
  }

  forUae(): boolean {
    return this.user?.userData?.id == 530;
  }

  authenticated(): boolean {
    return this.user?.userData?.role;
  }

  closeMenu() {
    this.onClose.emit(true);
  }

  logout() {
    this.onLogout.emit(true);
  }

  protected readonly faCar = faCar;
}
